import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-termini-utilizzo',
  templateUrl: './dialog-termini-utilizzo.component.html',
  styleUrls: ['./dialog-termini-utilizzo.component.css']
})
export class DialogTerminiUtilizzo {

  accettazioneClausole: boolean;
  accettazioneCondizioniGenerali: boolean;

  constructor(public dialogRef: MatDialogRef<DialogTerminiUtilizzo>,
    @Inject(MAT_DIALOG_DATA) public data: {accettazioneCondizioniGenerali: boolean,accettazioneClausole: boolean}) 
  {
    this.accettazioneCondizioniGenerali = data.accettazioneCondizioniGenerali;
    this.accettazioneClausole = data.accettazioneClausole;
  }

  close(){
    this.dialogRef.close(
      {accettazioneCondizioniGenerali: this.accettazioneCondizioniGenerali,accettazioneClausole: this.accettazioneClausole}
    );
  }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-termini-utilizzo/dialog-termini-utilizzo.component.ts